import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useProjectOrganizationId } from 'store/project';
import {
  createDocumentationValueGetters,
  DocumentationValueGetters,
} from 'components/common/dataGrid/columnsFactory/valueGetters';

export type { DocumentationValueGetters } from 'components/common/dataGrid/columnsFactory/valueGetters';

export function useValueGetters(): DocumentationValueGetters {
  const organizationId = useProjectOrganizationId();
  const intl = useIntl();

  return useMemo(
    () =>
      createDocumentationValueGetters({
        organizationId,
        intl,
      }),
    [organizationId, intl]
  );
}
